import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { GLOBAL } from '../global';
import { GenericRequestReports } from '../domain/generic-request-reports';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DetallePedidoService {
  urlDetallePedido: string;
  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };
  /**
   * @author Daniel Pareja Londoño
   * @version 2018-11-15
   * @param httpClient
   */
  constructor(
    public httpClient: HttpClient
  ) {
    this.urlDetallePedido = GLOBAL.URL_BASE+'sicaDetallePedido';
  }

  /**
   * @author Daniel Pareja Londoño
   * @version 2018-11-17
   * @param genericRequestReports 
   */
  reportSoldPartsPeriodTime(genericRequestReports:GenericRequestReports):Observable<any>{
    return this.httpClient.post(this.urlDetallePedido+'/reportSoldPartsPeriodTime',genericRequestReports,this.httpOptions);
  }
}
